export const getItems: <T>(state: T) => T = (state) => ({
  ...state,
  loading: true,
});

export const updateItems: <T>(state: T) => T = (state) => ({
  ...state,
  updateLoading: true,
});

export const getItemsSuccess: <T, U>(state: T, _: { items: U }) => T
  = (state, { items }) => ({
    ...state,
    items,
    loading: false,
  });

export const getItemsFailure: <T>(state: T) => T = (state) => ({
  ...state,
  loading: false,
});

export const clearList: <T>(state: T) => T
  = state => ({
  ...state,
  items: [],
});

export const set: <T>(state: T) => T = (state) => ({
  ...state,
  loading: false,
});

export const setSearchFilter: <T>(state: T, _: { searchFilter: string }) => T = (state, { searchFilter }) => ({
  ...state,
  searchFilter,
});

export const setPageSize: <T>(state: T, _: { pageSize: number }) => T = (state, { pageSize }) => ({
  ...state,
  pageSize,
  loading: true,
  currentPage: 1,
});

export const setCurrentPage: <T>(state: T, _: { currentPage: number }) => T = (state, { currentPage }) => ({
    ...state,
    currentPage,
    loading: true,
});

export const updateFilter: <T>(state: T, _: { filter: any }) => T = (state, { filter }) => ({
  ...state,
  filter,
});

export const setItemsCount: <T>(state: T, _: { itemsCount: number }) => T = (state, { itemsCount }) => ({
  ...state,
  itemsCount,
});
